import Decimal from 'decimal.js'

/** 金额与单价统一显示两位小数；不修改服务端原值或历史快照。 */
export function formatAmount(value: unknown) {
  if ((typeof value !== 'string' && typeof value !== 'number') || String(value).trim() === '') {
    return '—'
  }
  try {
    const amount = new Decimal(value)
    return amount.isFinite() ? amount.toFixed(2, Decimal.ROUND_HALF_UP) : '—'
  } catch {
    return '—'
  }
}

export function formatAmountInput(value: string | number | undefined, info: { userTyping: boolean; input: string }) {
  if (info.userTyping) return info.input
  if (value === undefined || value === '') return ''
  return formatAmount(value)
}
